export const BANK_PATH = "api/banks";
